var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsStarSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/sms-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 11.5V15.5C22 19 20 20.5 17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H12",
    stroke: "#2A3142",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 9L10.13 11.5C11.16 12.32 12.85 12.32 13.88 11.5",
    stroke: "#2A3142",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4802 2.81994L19.7602 3.38993C19.9002 3.66993 20.2502 3.92994 20.5602 3.98994L20.9402 4.04994C22.0802 4.23994 22.3502 5.07994 21.5302 5.90994L21.1802 6.25993C20.9502 6.49993 20.8202 6.95993 20.8902 7.27993L20.9402 7.48994C21.2502 8.86994 20.5202 9.39993 19.3202 8.67993L19.0602 8.52993C18.7502 8.34993 18.2502 8.34993 17.9402 8.52993L17.6802 8.67993C16.4702 9.40993 15.7402 8.86994 16.0602 7.48994L16.1102 7.27993C16.1802 6.95993 16.0502 6.49993 15.8202 6.25993L15.4702 5.90994C14.6502 5.07994 14.9202 4.23994 16.0602 4.04994L16.4402 3.98994C16.7402 3.93994 17.1002 3.66993 17.2402 3.38993L17.5202 2.81994C18.0602 1.72994 18.9402 1.72994 19.4802 2.81994Z",
    stroke: "#2A3142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsStarSvg);
export default __webpack_public_path__ + "static/media/SmsStarSvg.68301afbce381b70d15953aa0a28bb23.svg";
export { ForwardRef as ReactComponent };